import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";
import Marquee from "react-fast-marquee";
import Menu from "./Menu";
import Booking from "./Booking";
import Slider from "./Slider";
import Dataentry from "./Dataentry";
import SiteFooter from "./SiteFooter";
import axios from 'axios';
import Live from './Live';
import Popup from './Popup';
import Rightside from './Rightside';

// const API_BASE = "http://localhost/myapp/api/uploads";

const API_BASE = "https://spst.in/myapp/api/uploads";

function NewsEvents() {

   const [uploads, setUploads] = useState([]);
  const [editId, setEditId] = useState(null);
  const [editName, setEditName] = useState('');

  useEffect(() => {
    fetchUploads();
  }, []);

  const fetchUploads = async () => {
    const res = await axios.get(`${API_BASE}/get.php`);
    setUploads(res.data);
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Delete this record?")) return;
    await axios.post(`${API_BASE}/delete.php`, { id });
    fetchUploads();
  };

  const startEdit = (item) => {
    setEditId(item.id);
    setEditName(item.name);
  };

  const saveEdit = async () => {
    await axios.post(`${API_BASE}/update.php`, { id: editId, name: editName });
    setEditId(null);
    fetchUploads();
  }; 



  return (
    <div>
    <div class="grouped_sections" style={{backgroundImage:'url(./images/spst.webp)',backgroundSize:'cover',backgroundAttachment:'fixed',backgroundPosition:'center'}}>
   
		<div class="container">
			<div class="row">

				

				{/* <!-- News --> */}

				<div class="col-lg-12 grouped_col" style={{background:'rgba(237, 237, 237, 0.99)',padding:'35px'}}>
					<div class="grouped_title" style={{color:'black',fontWeight:'300'}}>Tenders</div>
					<div>
						{/* <!-- News Post --> */}
            {uploads.map((upload) => (
						<div class="news_post d-flex flex-row align-items-start justify-content-start box">
							<div><div class="news_post_image"><img src="./images/slider1.jpeg" alt="https://unsplash.com/@beccatapert" /></div></div>
							<div class="news_post_body">
								{/* <div class="news_post_date"> {upload.uploaded_at}</div> */}
								<div class="news_post_title" >
                  <a style={{color:'maroon',cursor:'pointer',fontFamily:'anek malayalam'}} href={`myapp/${upload.file_path}`} >
                    {upload.name}
                  </a>
                {/* <span style={{color:'maroon',cursor:'pointer'}} onClick={() => window.open('{`myapp/${upload.file_path}', "_blank")} >{upload.name}</span> */}
                
                </div>
								{/* <div class="news_post_author">By <a href="#">William Smith</a></div> */}
							</div>
						</div>
             ))}
            {uploads.length === 0 && (
              <tr>
                <td colSpan="5">-</td>
              </tr>
            )}
              
						
						
						


						
					</div>
				</div>
			</div>
		</div>
	</div>


	



      </div>
    
  );
}

export default NewsEvents;